import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import RenderTemplateRequest from '@app/models-internal/render-template-request';
import RenderTemplateResponse from '@app/models-internal/render-template-response';
import TemplateViewModel from '@app/models/template-view-model';

import { HttpHelperService } from '@oa/shared-core';
import { LogService } from '@oa/shared-core';

@Injectable({
  providedIn: "root",
})
export class TemplateService {
  private readonly _componentName = 'TemplateService';

  constructor(private log: LogService, private http: HttpClient, private httpHelper: HttpHelperService) {}

  /**
   * Sends template text and data to the API for rendering (using Handlebars.NET).
   * @param request
   * @returns
   */
  public renderTemplate(request: RenderTemplateRequest) {
    return this.http.post<RenderTemplateResponse>('template/render', request);
  }

  /**
   * Gets all available templates
   * @returns 
   */
  public getAll() {
    return this.http.get<TemplateViewModel[]>('template');
  }

}
